import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import {Checkbox, Chip, FormControl, InputBase, MenuItem} from "@material-ui/core";
import ListItemText from "@material-ui/core/ListItemText";
import React from "react";
import styled from "styled-components";
import {RootState} from "../../store/root-reducer";
import {useSelector} from "react-redux";
import {makeStyles, withStyles} from "@material-ui/core/styles";


const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.common.white,
            // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    margin: {
        width: '100%'
    },
    label: {
        color: '#000',
        fontSize: '1.2rem'
    }
}));

export const MultipleSelect: React.FC<Props> = ({label, value, options,  error, optionsLabel, disabled = false, errorMessage = '', fieldName, setFieldValue}) => {
    const classes = useStyles();

    return (
        <StyledFormControl error={error} className={classes.margin} disabled={disabled}>
            <InputLabel shrink htmlFor={fieldName} className={classes.label}>{label}</InputLabel>
            <Select
                id={fieldName}
                multiple
                value={value}
                onChange={(e, tmpVal: any) => {
                    if (value.indexOf(tmpVal.props.value) !== -1) {
                        setFieldValue(fieldName, value.filter(val => val !== tmpVal.props.value));
                    } else {
                        setFieldValue(fieldName, [...value, tmpVal.props.value]);
                    }
                }}
                inputProps={{
                    id: fieldName,
                    name: fieldName
                }}
                input={<BootstrapInput/>}
                renderValue={(selected: any[]) => (
                    <div>
                        {selected.map((value) => (
                            <Chip key={optionsLabel(JSON.parse(value))} label={optionsLabel(JSON.parse(value))}/>
                        ))}
                    </div>
                )}
            >
                {options.map((option, index) => (
                    <MenuItem key={index} value={JSON.stringify(option)}>
                        <Checkbox checked={value.indexOf(JSON.stringify(option)) > -1}/>
                        <ListItemText primary={optionsLabel(option)}/>
                    </MenuItem>
                ))}
            </Select>
        </StyledFormControl>
    )
}

interface Props {
    label: string,
    value: any,
    options: any,
    error?: boolean,
    errorMessage?: string,
    optionsLabel: (option: any) => string,
    disabled?: boolean,
    fieldName: string,
    setFieldValue: any,
}

const StyledFormControl = styled(FormControl)`
    width: 100%;
`;
